module.exports = __webpack_public_path__ + "fonts/e0655c6.otf";